<template>
	<div class="home">

		<!-- 顶部工具栏：搜索、添加、导出 -->
		<div class="search_line">
			<div class="first_search_line">
				<el-autocomplete v-if="userType=='admin'" class="auto_comp_2" clearable
					v-model="search_data.school_name" :fetch-suggestions="querySearch" size="mini" placeholder="学校" />
				<el-select style="width: 250px;margin-left: 20px;margin-right: 20px;" v-model="search_data.level" clearable
					placeholder="学历" size="mini">
					<el-option v-for="item in ['初中','高中']" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
				<el-tooltip style="width: 250px;margin-right: 20px;" effect="dark" content="如: 2020"
					placement="top-start">
					<el-input clearable v-model="search_data.grade" size="mini" placeholder="年级" />
				</el-tooltip>
<!-- 				<el-date-picker style="width: 200px;margin-right: 20px;" size="mini" v-model="search_data.grade" type="year" placeholder="年级" value-format="yyyy">
				</el-date-picker> -->
				<el-select style="width: 250px;margin-right: 20px;" v-model="search_data.major" clearable
					placeholder="专项" size="mini">
					<el-option v-for="item in major_options" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
				<el-input style="width: 250px;margin-right: 20px;" v-if="userType!='teacher'" clearable
					v-model="search_data.teacher_name" size="mini" placeholder="教师姓名" />
				<el-input style="width: 250px;margin-right: 20px;" clearable v-model="search_data.class_name"
					size="mini" placeholder="班级名称" />
				<el-input style="width: 250px;margin-right: 20px;" clearable v-model="search_data.small_class"
					size="mini" placeholder="行政班级" />
				<el-input style="width: 250px;margin-right: 20px;" clearable v-model="search_data.sid" size="mini"
					placeholder="学号" />
				<el-input style="width: 250px;margin-right: 20px;" clearable v-model="search_data.student_name"
					size="mini" placeholder="姓名" />
				<el-select style="width: 250px;margin-right: 20px;" v-model="search_data.male" clearable
					placeholder="性别" size="mini">
					<el-option v-for="item in ['男','女']" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>
			<div class="second_search_line">
				<el-button class="search_bt" type="danger" icon="el-icon-search" size="mini" @click="getStudentInfo()">
					搜索
				</el-button>
				<el-button class="search_bt" type="primary" icon="el-icon-plus" size="mini" @click="handleAdd()" v-cloak  v-show="userinfo.permit!='1'">
					添加
				</el-button>
				<el-button class="export_bt" type="warning" icon="el-icon-upload2" size="mini" @click="import_dialog()" v-cloak  v-if="userinfo.permit!='1'">
					导入
				</el-button>
				<el-button class="export_bt" type="success" icon="el-icon-download" size="mini"
					@click="exportStudent()">
					导出
				</el-button>
			</div>
		</div>

		<!-- 内容表格 -->
		<el-table :data="tableData" :header-cell-style="{background:'#409EFF',color:'white'}" size="mini">
			<el-table-column prop="sid" label="学号" width="150" />
			<el-table-column prop="name" label="姓名" width="100"/>
			<el-table-column prop="male" label="性别" width="50" />
			<el-table-column prop="height" label="身高cm" width="70"/>
			<el-table-column prop="weight" label="体重kg" width="70"/>
			<el-table-column prop="phone" label="电话" width="120" />
			<el-table-column prop="nation" label="民族" width="80"/>
			<!-- <el-table-column prop="birthplace" label="籍贯" width="130" /> -->
			<!-- <el-table-column prop="personalId" label="身份证号" width="160" /> -->
			<el-table-column prop="grade" label="年级" width="100"/>
			<el-table-column prop="className" label="班级" width="160"/>
			<el-table-column prop="major" label="专项" width="70"/>
			<el-table-column prop="teacherName" label="教师姓名" width="120"/>
			<el-table-column prop="smallClass" label="行政班级" width="133"/>
			<el-table-column prop="schoolName" label="学校" width="180" />

			<el-table-column prop="delete" label="成绩分析" width="80">
				<template slot-scope="scope">
					<el-button type="text" size="mini" class="analysis_bt" @click="handleAnalysis(scope.row)"><i
							class="el-icon-monitor" style="margin-left: 20px;"></i>
					</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="edit" label="修改" width="60"   v-if="userinfo.permit!='1'" v-cloak>
				<template slot-scope="scope">
					<el-button @click="handleEdit(scope.row)" type="text" size="mini" class="edit_bt"><i
							class="el-icon-edit-outline"></i></el-button>
				</template>
			</el-table-column>
			<el-table-column prop="delete" label="删除" width="60"   v-if="userinfo.permit!='1'" v-cloak>
				<template slot-scope="scope">
					<el-button type="text" size="mini" class="delete_bt" @click="handleDelete(scope.row)"><i
							class="el-icon-delete"></i>
					</el-button>
				</template>
			</el-table-column>

		</el-table>
		<div class="pagination">
			<el-pagination background layout="total, prev, pager, next" @current-change="handleCurrentChange"
				:total="total_num">
			</el-pagination>
		</div>








		<!-- 导入弹窗 -->
		<el-dialog class="import_dialog" title="导入学生" :visible.sync="dialogImportStudentVisible" top="5vh">
			<div class="input_title">
				<span>下载模板</span>
			</div>
			<div>
				<el-button type="primary" size='small' icon="el-icon-sold-out" style="width: 80%;"
					@click="down_student_templete()">学生信息表格模板</el-button>
			</div>
			<div class="input_title">
				<span>导入学生信息</span>
			</div>
			<!-- 			<div>
				<el-button type="primary" size='small' icon="el-icon-upload" style="width: 80%">导入学生信息Excel表格
				</el-button>
			</div> -->
			<div @click="clearList()">
				<el-upload ref="upload" :file-list="file_list" :limit="1" :on-error="import_error"
					:on-success="import_success" :auto-upload="false" drag
					:action="'/jfapi/importStudent?userType='+userType">
					<i class="el-icon-upload"></i>
					<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					<div class="el-upload__tip" slot="tip">请按照“学生信息表格模板”的格式上传</div>
				</el-upload>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="dialogImportStudentVisible = false">
					取 消
				</el-button>
				<el-button size="small" type="primary" @click="import_student()">
					导 入
				</el-button>
			</div>
		</el-dialog>





		<!-- 添加学生弹窗 -->
		<el-dialog title="添加学生" :visible.sync="dialogstudentAddVisible" top="5vh">
			<div class="input_title" v-if="userType=='admin'">
				<span>学校</span>
			</div>
			<div>
				<el-autocomplete v-if="userType=='admin'" clearable v-model="update_data.school_name"
					:fetch-suggestions="querySearch" placeholder="请输入学校名称" size="small"
					style="width: 80%;" />
				<!-- 				<el-input size="small" v-if="userType!='admin'" v-model="schoolName"
					suffix-icon="el-icon-s-custom"  @focus="showTip=false" disabled /> -->
			</div>

			<div class="input_title">
				<span>年级</span>
			</div>
			<div>
				<el-input size="small" v-model="update_data.grade" suffix-icon="el-icon-s-grid" placeholder="请输入学生年级" />
			</div>

			<div class="input_title">
				<span>班级</span>
			</div>
			<div>
				<el-autocomplete clearable v-model="update_data.class_name" :fetch-suggestions="querySearch"
					:trigger-on-focus="false" placeholder="请输入班级名称" size="small" style="width: 80%;" />
				<!-- 				<el-input size="small" v-if="userType=='school'" v-model="update_data.class_name"
					suffix-icon="el-icon-s-custom"   @focus="showTip=false" disabled /> -->
			</div>
			
			<div class="input_title">
				<span>行政班级</span>
			</div>
			<div>
				<el-autocomplete clearable v-model="update_data.small_class" :fetch-suggestions="querySearch"
					:trigger-on-focus="false" placeholder="请输入行政班级名称" size="small" style="width: 80%;" />
				<!-- 				<el-input size="small" v-if="userType=='school'" v-model="update_data.class_name"
					suffix-icon="el-icon-s-custom"   @focus="showTip=false" disabled /> -->
			</div>

			<div class="input_title">
				<span>专业</span>
			</div>
			<div>
				<!-- <el-input size="small"  v-model="male" suffix-icon="el-icon-female"/> -->
				<el-select style="width: 80%;margin-left: 0%;" v-model="update_data.major" placeholder="请选择专业" size="small">
					<el-option v-for="item in major_options" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>

			<div class="input_title">
				<span>学生学号</span>
			</div>
			<div>
				<el-input size="small" v-model="update_data.sid" suffix-icon="el-icon-s-grid" placeholder="请输入学生学号" />
			</div>

			<div class="input_title">
				<span>学生姓名</span>

			</div>
			<div>
				<el-input size="small" placeholder="请输入学生姓名" v-model="update_data.student_name"
					suffix-icon="el-icon-s-custom" @focus="showTip=false" />
			</div>

			<div class="input_title">
				<span>性别</span>
			</div>
			<div>
				<!-- <el-input size="small"  v-model="male" suffix-icon="el-icon-female"/> -->
				<el-select style="width: 80%;margin-left: 0%;" v-model="update_data.male" placeholder="请选择性别" size="small">
					<el-option v-for="item in ['男','女']" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>



			<div class="input_title">
				<span>电话</span>
			</div>
			<div>
				<el-input size="small" v-model="update_data.phone" suffix-icon="el-icon-phone-outline"
					@focus="showTip=false" placeholder="请输入电话号码" />
			</div>



			<div slot="footer" class="dialog-footer">
				<span v-show="showTip">
					<font>{{result}}</font>
				</span>
				<el-button size="small" type="primary" @click="dialogstudentAddVisible = false">
					取 消
				</el-button>
				<el-button size="small" type="primary" @click="add()">
					确 定
				</el-button>
			</div>

			<div class="input_title">
				<span>民族</span>
			</div>
			<div>
				<!-- <el-input size="small"  v-model="male" suffix-icon="el-icon-female"/> -->
				<el-select style="width: 80%;margin-left: 0%;" v-model="update_data.nation" placeholder="请选择民族" size="small">
					<el-option v-for="item in nation" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>

			<div class="input_title">
				<span>籍贯</span>
			</div>
			<div>
				<!-- <el-input size="small"  v-model="male" suffix-icon="el-icon-female"/> -->
				<el-select style="width: 80%;margin-left: 0%;" v-model="update_data.birthplace" placeholder="请选择籍贯" size="small">
					<el-option v-for="item in birthplace" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>

<!-- 			<div class="input_title">
				<span>身份证号码</span>
			</div>
			<div>
				<el-input size="small" v-model="update_data.personalID" suffix-icon="el-icon-user-solid"
					placeholder="请输入学生身份证号码" />
			</div> -->
			<div class="input_title">
				<span>身高</span>
			</div>
			<div>
				<el-input size="small" v-model="update_data.height" suffix-icon="el-icon-wind-power"
					placeholder="单位(cm)" />
			</div>
			<div class="input_title">
				<span>体重</span>
			</div>
			<div>
				<el-input size="small" v-model="update_data.weight" suffix-icon="el-icon-coordinate"
					placeholder="单位(kg)" />
			</div>
		</el-dialog>



		<!-- 修改学生信息 -->
		<el-dialog title="修改" :visible.sync="dialogstudentEditVisible" top="5vh">
			<div class="input_title" v-if="userType=='admin'">
				<span>学校</span>
			</div>
			<div>
				<el-autocomplete v-if="userType=='admin'" clearable v-model="update_data.school_name"
					:fetch-suggestions="querySearch" :trigger-on-focus="false" placeholder="请输入学校名称" size="small"
					style="width: 80%;" />
				<el-input size="small" v-if="userType=='school'" v-model="update_data.schoolName"
					suffix-icon="el-icon-s-custom" @focus="showTip=false" disabled />
			</div>

			<div class="input_title">
				<span>年级</span>
			</div>
			<div>
				<el-input size="small" v-model="update_data.grade" suffix-icon="el-icon-s-grid" placeholder="请输入学生年级" />
			</div>

			<div class="input_title">
				<span>班级</span>
			</div>
			<div>
				<el-autocomplete clearable v-model="update_data.class_name" :fetch-suggestions="querySearch"
					:trigger-on-focus="false" placeholder="请输入班级名称" size="small" style="width: 80%;" />
				<el-input size="small" v-if="userType=='school'" v-model="update_data.class_name"
					suffix-icon="el-icon-s-custom" @focus="showTip=false" disabled />
			</div>
			
			<div class="input_title">
				<span>行政班级</span>
			</div>
			<div>
				<el-autocomplete clearable v-model="update_data.small_class" :fetch-suggestions="querySearch"
					:trigger-on-focus="false" placeholder="请输入行政班级名称" size="small" style="width: 80%;" />
				<el-input size="small" v-if="userType=='school'" v-model="update_data.small_class"
					suffix-icon="el-icon-s-custom" @focus="showTip=false" disabled />
			</div>

			<div class="input_title">
				<span>专业</span>
			</div>
			<div>
				<!-- <el-input size="small"  v-model="male" suffix-icon="el-icon-female"/> -->
				<el-select  style="width: 80%;margin-left: 0%;" v-model="update_data.major" placeholder="请选择专业" size="small">
					<el-option v-for="item in major_options" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>

			<div class="input_title">
				<span>学生学号</span>
			</div>
			<div>
				<el-input size="small" v-model="update_data.sid" suffix-icon="el-icon-s-grid" placeholder="请输入学生学号" />
			</div>

			<div class="input_title">
				<span>学生姓名</span>

			</div>
			<div>
				<el-input size="small" placeholder="请输入学生姓名" v-model="update_data.student_name"
					suffix-icon="el-icon-s-custom" @focus="showTip=false" />
			</div>

			<div class="input_title">
				<span>性别</span>
			</div>
			<div>
				<!-- <el-input size="small"  v-model="male" suffix-icon="el-icon-female"/> -->
				<el-select  style="width: 80%;margin-left: 0%;" v-model="update_data.male" placeholder="请选择性别" size="small">
					<el-option v-for="item in ['男','女']" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>



			<div class="input_title">
				<span>电话</span>
			</div>
			<div>
				<el-input size="small" v-model="update_data.phone" suffix-icon="el-icon-phone-outline"
					@focus="showTip=false" placeholder="请输入电话号码" />
			</div>

			<div class="input_title">
				<span>民族</span>
			</div>
			<div>
				<!-- <el-input size="small"  v-model="male" suffix-icon="el-icon-female"/> -->
				<el-select style="width: 80%;margin-left: 0%;" v-model="update_data.nation" placeholder="请选择民族" size="small">
					<el-option v-for="item in nation" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>

			<div class="input_title">
				<span>籍贯</span>
			</div>
			<div>
				<!-- <el-input size="small"  v-model="male" suffix-icon="el-icon-female"/> -->
				<el-select  style="width: 80%;margin-left: 0%;" v-model="update_data.birthplace" placeholder="请选择籍贯" size="small">
					<el-option v-for="item in birthplace" :key="item" :label="item" :value="item">
					</el-option>
				</el-select>
			</div>

<!-- 			<div class="input_title">
				<span>身份证号码</span>
			</div>
			<div>
				<el-input size="small" v-model="update_data.personalID" suffix-icon="el-icon-user-solid"
					placeholder="请输入学生身份证号码" />
			</div> -->
			<div class="input_title">
				<span>身高</span>
			</div>
			<div>
				<el-input size="small" v-model="update_data.height" suffix-icon="el-icon-wind-power"
					placeholder="单位(cm)" />
			</div>
			<div class="input_title">
				<span>体重</span>
			</div>
			<div>
				<el-input size="small" v-model="update_data.weight" suffix-icon="el-icon-coordinate"
					placeholder="单位(kg)" />
			</div>

			<div slot="footer" class="dialog-footer">
				<span v-show="showTip">
					<font>{{result}}</font>
				</span>
				<el-button size="small" type="primary" @click="dialogstudentEditVisible = false">
					取 消
				</el-button>
				<el-button size="small" type="primary" @click="edit()">
					确 定
				</el-button>
			</div>


		</el-dialog>









	</div>
</template>

<script>
	export default {
		name: "Student",
		data() {
			return {
				userType: window.localStorage.getItem("userType"),
				userinfo:'',
				update_data: {
					sid: '',
					student_name: '',
					male: '',
					// personalID: '',
					school_name: '',
					phone: '',
					grade: '',
					class_name: '',
					major: '',
					id: '',
					height: '',
					weight: '',
					small_class:''
				},
				search_data: {
					state: '',
					school_name: '',
					level: '',
					grade: '',
					major: '',
					teacher_name: '',
					sid: '',
					student_name: '',
					male: '',
					class_name: '',
					school: '',
					small_class:'',
					// personalID: '',
				},
				major_options: ['田径', '体操', '足球', '篮球', '武术', '排球', '游泳'],
				tableData: [],
				total_num: 0,
				dialogstudentAddVisible: false,
				showTip: false,
				result: '',
				dialogstudentEditVisible: false,
				dialogImportStudentVisible: false,
				file_list: [],
				nation: ['汉族', '回族', '白族', '蒙古族', '满族', '朝鲜族', '赫哲族', '达斡尔族', '鄂温克族', '鄂伦春族',
					'东乡族', '土族', '撒拉族', '保安族', '裕固族', '维吾尔族', '哈萨克族',
					'柯尔克孜族', '锡伯族', '塔吉克族', '乌孜别克族', '俄罗斯族', '塔塔尔族', '藏族', '门巴族',
					'珞巴族', '羌族', '彝族', '哈尼族', '傣族', '僳僳族', '佤族',
					'拉祜族', '纳西族', '景颇族', '布朗族', '阿昌族', '普米族', '怒族', '德昂族',
					'独龙族', '基诺族', '苗族', '布依族', '侗族', '水族', '仡佬族', '壮族',
					'瑶族', '仫佬族', '毛南族', '京族', '土家族', '黎族', '畲族', '高山族'
				],
				birthplace: ['云南省', '贵州省', '四川省', '重庆市', '北京市', '广东省', '山东省', '江苏省',
					'河南省', '上海市', '河北省', '浙江省', '陕西省', '湖南省', '福建省', '天津市',
					'广西壮族自治区', '安徽省', '海南省', '江西省', '湖北省', '山西省', '辽宁省', '台湾省',
					'黑龙江', '内蒙古自治区', '澳门特别行政区', '香港特别行政区', '甘肃省', '青海省', '新疆维吾尔自治区', '西藏区',
					'吉林省', '宁夏回族自治区'
				]
			}
		},
		mounted() {
			this.getStudentInfo();
		},
		methods: {
			getStudentInfo(page) {
				page = !page ? 1 : page
				const that = this
				let data = {
					userType: that.userType,
					page: page,
					school_name: that.search_data.school_name,
					level: that.search_data.level,
					grade: that.search_data.grade,
					major: that.search_data.major,
					teacher_name: that.search_data.teacher_name,
					class_name: that.search_data.class_name,
					sid: that.search_data.sid,
					student_name: that.search_data.student_name,
					male: that.search_data.male,
					small_class: that.search_data.small_class,
				}
				// 获取信息
				this.$axios({
					method: 'post',
					url: '/jfapi/getStudentInfo',
					data: that.qs.stringify(data),
				}).then(function(res) {
					// console.log(res.data)
					that.tableData = res.data.records
					that.total_num = res.data.total
				});

				// 获取用户信息
				that.$axios({
					url: '/jfapi/userinfo/' + that.userType
				}).then(function(res) {
					that.userinfo = res.data
				})
			},
			querySearch(queryString, cb) {
				this.$axios({
					url: '/jfapi/getSchollHint?queryString=' + queryString,
				}).then(function(res) {
					cb(res.data)
				});
			},
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getStudentInfo(val)
			},
			search(name) {
				// if (!name)
				// 	return
				this.getStudentInfo(1, name)
			},
			//添加学生,把数据清空
			handleAdd(row) {
				for (let key in this.update_data) {
					this.update_data[key] = ''
				}
				this.dialogstudentAddVisible = true
			},


			add() {
				if (this.userType != 'admin') {
					this.update_data.school_name = this.tableData[0].schoolName
				}
				for (let key in this.update_data) {
					let item = this.update_data[key]
					if (item == '' && key != 'class_id' && key != 'id') {
						// console.log(key)
						this.result = "请填写完整!"
						this.showTip = true
						return
					}
				}
				let data = {
					school_name: this.update_data.school_name,
					grade: this.update_data.grade,
					class_name: this.update_data.class_name,
					small_class: this.update_data.small_class,
					major: this.update_data.major,
					sid: this.update_data.sid,
					student_name: this.update_data.student_name,
					male: this.update_data.male,
					phone: this.update_data.phone,
					nation: this.update_data.nation,
					birthplace: this.update_data.birthplace,
					// personalID: this.update_data.personalID,
					height: this.update_data.height,
					weight: this.update_data.weight,
					userType: this.userType
				}
				// console.log(data)
				const that = this
				this.$axios({
					method: 'post',
					url: '/jfapi/addStudent',
					data: that.qs.stringify(data)
				}).then(function(res) {
					// console.log(res.data)
					if (res.data == 'success') {
						that.getStudentInfo()
						that.dialogstudentAddVisible = false
					} else {
						that.result = res.data
						that.showTip = true
					}
				});
			},

			handleEdit(row) {
				this.dialogstudentEditVisible = true

				this.update_data.id = row.id
				this.update_data.school_name = row.schoolName
				this.update_data.grade = row.grade
				this.update_data.class_name = row.className
				this.update_data.major = row.major
				this.update_data.sid = row.sid
				this.update_data.student_name = row.name
				this.update_data.male = row.male
				this.update_data.phone = row.phone
				this.update_data.nation = row.nation
				this.update_data.birthplace = row.birthplace
				this.update_data.height = row.height
				this.update_data.weight = row.weight
				this.update_data.small_class = row.smallClass
			},

			edit() {
				if (this.userType != 'admin') {
					this.update_data.school_name = this.tableData[0].schoolName
				}
				for (let key in this.update_data) {
					let item = this.update_data[key]
					if (item == '' && key != 'class_id') {
						this.result = "请填写完整!"
						this.showTip = true
						return
					}
				}
				let data = {
					id: this.update_data.id,
					school_name: this.update_data.school_name,
					grade: this.update_data.grade,
					class_name: this.update_data.class_name,
					small_class: this.update_data.small_class,
					major: this.update_data.major,
					sid: this.update_data.sid,
					student_name: this.update_data.student_name,
					male: this.update_data.male,
					phone: this.update_data.phone,
					nation: this.update_data.nation,
					birthplace: this.update_data.birthplace,
					// personalID: this.update_data.personalID,
					height: this.update_data.height,
					weight: this.update_data.weight,
					userType: this.userType
				}
				// console.log(data)
				const that = this
				this.$axios({
					method: 'post',
					url: '/jfapi/editStudent',
					data: that.qs.stringify(data)
				}).then(function(res) {
					// console.log(res.data)
					if (res.data == 'success') {
						that.getStudentInfo()
						that.dialogstudentEditVisible = false
					} else {
						that.result = res.data
						that.showTip = true
					}
				});
			},
			handleDelete(row) {
				var r = confirm("确认删除吗？");
				if (r == true) {
					const that = this
					this.$axios({
						url: '/jfapi/delStudent?id=' + row.id + '&userType=' + that.userType,
					}).then(function(res) {
						that.getStudentInfo()
					});
				}

			},


			import_dialog() {
				this.file_list = [];
				this.dialogImportStudentVisible = true;

			},
			down_student_templete() {
				window.location.href = "/jfapi/down_student_templete"
			},
			import_student() {
				this.$refs.upload.submit()
			},
			import_error(res) {
				// console.log(res)
				this.$message({
					message: res,
					type: 'error',
					duration: 3000
				});

			},
			import_success(res) {
				// console.log(res)
				var msg = res
				var msgType = 'error'
				if (res == 'success') {
					msgType = 'success'
					msg = '上传成功！'
				} else {
					msg = "上传中止，" + res
				}
				this.$message({
					message: msg,
					type: msgType,
					duration: 3000
				});
				this.getStudentInfo();
				this.dialogImportStudentVisible = false;
			},
			clearList() {
				this.file_list = [];
			},
			exportStudent() {
				window.location.href = '/jfapi/exportStudent?school_name=' + this.search_data.school_name + '&grade=' +
					this
					.search_data.grade + '&class_name=' + this.search_data.class_name + '&userType=' + this.userType
			},
			handleAnalysis(row){
				var that = this
				this.$axios({
					url: 'jfapi/score/hasScore?stu_id=' + row.id
				}).then(function(res){
					if(res.data == false){
						that.$message({
							message: '该学生还未录入成绩！',
							type: 'error',
							duration: 2000
						});
					}else{
						that.$router.push({
							path: '/analysis?stu_id=' + row.id + '&stu_sid=' + row.sid + '&stu_name=' + row.name 
						});
					}
				})
			},
		}
	};
</script>

<style lang="scss" scoped>
	.search_line {
		display: flex;
		width: 90%;
		flex-wrap: wrap;
		justify-content: space-between;
		padding-left: 10px;
		padding-right: 10px;
	}

	.first_search_line {
		width: 100%;
		display: flex;
		margin-left: 22px;
		justify-content: flex-start;
	}

	.second_search_line {
		width: 80%;
		display: flex;
		justify-content: flex-start;
		margin-left: 18px;
		margin-top: 10px;
	}

	.auto_comp_2 {
		width: 400px;
	}

	.auto_comp_2 .el-input {
		width: 80%;
	}

	input {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.search_bt {
		margin-left: 5px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.export_bt {
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.el-table {
		margin-top: 10px;
		font-size: small;
		width: 96%;
		margin-left: 2%;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) // box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	}

	.edit_bt {
		color: #00ff7f;
	}

	.delete_bt {
		color: red;
	}
	.analysis_bt{
		color: #409EFF;
	}

	.pagination {
		width: 90%;
		margin-left: 5%;
		margin-top: 10px;
		display: flex;
		justify-content: flex-end;
	}

	.input_title span {
		margin: 0;
		color: #959595;
		font-size: 10px;
	}

	.input_title {
		display: flex;
		justify-content: space-between;
		width: 80%;
		margin-left: 10%;
		margin-top: 10px;
	}

	// .el-input {
	// 	width: 80%;
	// }

	.el-input__inner:focus {
		border-color: #00b27a;
	}

	.el-dialog__body {
		padding: 0;
	}

	.el-dialog {
		width: 40%;
		padding-top: 20px;
		padding-bottom: 20px;
	}

	.el-dialog .el-autocomplete {
		width: 100%;
	}

	font {
		color: #ff0000;
		margin-right: 10px;
	}

	.el-dialog div .el-input {
		width: 80%;
	}

	.el-dialog div .el-select {
		width: 100%;
		margin-left: 10%;
	}
	
	[v-cloak] {
	  display: none !important;
	}
</style>
